import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { clientsRef } from '../../tools/firebase';
import List from './components/List/List';

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [password, setPassword] = useState('');
  const [isCorrectPassword, setIsCorrectPassword] = useState(false);

  useEffect(() => {
    clientsRef.on('value', async snapchop => {
      const clientList = [];
      const clientsFirebase = await snapchop.val();

      for (const key in clientsFirebase) {
        clientList.push(clientsFirebase[key]);
      }

      setClients(clientList);
    });
  }, []);

  const handleInsertPassword = () => {
    if (password === 'Trusted321') {
      setIsCorrectPassword(true);
    } else {
      alert('el password insertado no es correcto');
    }
  };

  return (
    <div>
      <h4>Clientes registrados</h4>

      {isCorrectPassword ? (
        <List clients={clients} />
      ) : (
        <>
          <p>Por favor insertar la contraseña para acceder al catálogo de clientes</p>
          <TextField
            id="clients-password"
            label="Insertar clave"
            type="password"
            onChange={event => setPassword(event.target.value)}
            style={{
              width: '250px',
            }}
          />
          <br />
          <br />
          <Button onClick={handleInsertPassword} variant="contained" color="primary">
            Aceptar
          </Button>
        </>
      )}
    </div>
  );
};

export default Clients;
